/**
 * Walk RHF FieldErrors / nested objects and return the first `message` string.
 */

export function firstNestedErrorMessage(errors: unknown): string | undefined {
  if (errors == null || typeof errors !== 'object') return undefined
  const stack: unknown[] = [errors]
  while (stack.length > 0) {
    const cur = stack.pop()
    if (cur == null || typeof cur !== 'object') continue
    const rec = cur as Record<string, unknown>
    if (typeof rec.message === 'string' && rec.message.trim() !== '') {
      return rec.message
    }
    for (const v of Object.values(rec)) {
      if (v != null && typeof v === 'object') stack.push(v)
    }
  }
  return undefined
}

/**
 * Collect every RHF / Zod field `message` (depth-first) for validation review popups.
 * Skips walking into a node once a `message` is found (FieldError shape).
 */
export function collectNestedErrorMessages(errors: unknown): string[] {
  const messages: string[] = []

  const walk = (node: unknown) => {
    if (node == null || typeof node !== 'object') return
    const rec = node as Record<string, unknown>
    if (typeof rec.message === 'string' && rec.message.trim() !== '') {
      messages.push(rec.message.trim())
      return
    }
    for (const value of Object.values(rec)) {
      if (value != null && typeof value === 'object') walk(value)
    }
  }

  walk(errors)
  return messages
}
